import { render } from "./LoadingApi.vue?vue&type=template&id=57a1d5ee&scoped=true"
import script from "./LoadingApi.vue?vue&type=script&lang=js"
export * from "./LoadingApi.vue?vue&type=script&lang=js"

import "./LoadingApi.vue?vue&type=style&index=0&id=57a1d5ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a1d5ee"]])

export default __exports__